import React, { useState, useEffect } from 'react';
import './Elem6SaveDraftFloating.css'


const Elem6SaveDraftFloating = ({onClick}) => {

    const [showButton, setShowButton] = useState(true);

    useEffect(() => {
        function handleScroll() {
          const windowHeight = window.innerHeight;
          const documentHeight = document.documentElement.scrollHeight;
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const scrollPosition = documentHeight - windowHeight - scrollTop;
    
          setShowButton(scrollPosition > 0);
        }
    
        // Add event listener for scroll
        window.addEventListener('scroll', handleScroll);
        
        // Clean up function to remove event listener
        return () => {
          window.removeEventListener('scroll', handleScroll);
        };
      }, []);

      // function handleButtonClick() {
      //   // Implement your scroll to top functionality here
      //   window.scrollTo({
      //     top: 0,
      //     behavior: "smooth"
      //   });
      // }

    return (
        <div>
            {showButton && (
                    <span onClick={onClick} className="material-symbols-outlined SaveDraft-Floating">
                        Bookmark
                    </span>
                  )}

        </div>
    )
}

export default Elem6SaveDraftFloating
